<template>

    <!-- switched to button in VOT-288 to fix VOT-300 -->
    <!--    <a href="#"-->
    <button type="button"
            class="list-group-item list-group-item-action"
            v-bind:class="styling"
            v-bind:aria-current="ariaStatus"
            v-on:click="handleSelect"
    ><i v-if="hasVoted" class="bi-check text-success"></i>
        <span v-bind:class="textStyling">{{ propName }}</span>
    </button>

</template>

<script>
import MotionMixin from "../../../../mixins/motionStoreMixin";
import MeetingMixin from "../../../../mixins/meetingMixin";
import motionObjectMixin from "../../../../mixins/motionObjectMixin";
import {isReadyToRock} from "../../../../utilities/readiness.utilities";

export default {
    name: "proposition-select-row",

    /**
     * motion (the currently selected motion) will be available
     * via mixin. Hence this naming
     */
    props: ['motion'],


    mixins: [MeetingMixin, motionObjectMixin],

    data: function () {
        return {}
    },


    computed: {
    // asyncComputed: {
        propName: function () {
            if (isReadyToRock(this.motion)) return this.motion.info.name;

        },

        /**
         * Returns true if the user has already voted on this office
         */
        hasVoted: function () {
            if(!isReadyToRock(this.motion)) return false;
            return this.$store.getters.hasVotedOnMotion(this.motion);
        },

        /**
         * Returns true if there's a problem which
         * should prevent navigation or submission, e.g.,
         * overselection
         */
        isError: function () {
            if (!isReadyToRock(this.motion)) return '';

            return this.$store.getters.showOverSelectionWarningForMotion(this.motion);

            // return true;
        },

        /**
         * Whether the motion that has been handed to this
         * component is the one globally selected.
         *
         * Will not show as selected if the summary card is showing (even if
         * the given motion is the one currently on top of the stack)
         *
         * @returns {boolean}
         */
        isSelected: function () {
            if (_.isUndefined(this.selectedMotion) || _.isNull(this.selectedMotion)) return false

            //Do not show as selected if summary card is showing
            if (this.$store.getters.isSummarySubmitCardVisible) return false;
            if (this.$store.getters.isInstructionsCardVisible) return false;

            return this.motion.id === this.selectedMotion.id
        },

        //
        // isSelected: {get:function() {
        //         if (isReadyToRock(this.motion) && isReadyToRock(this.myMotion)) {
        //             window.console.log('rrtr', this.motion, this.myMotion);
        //             return this.motion === this.myMotion.id;
        //         }
        //         return false;
        //     }
        // },

        /**
         * The current globally active motion
         * @returns {any}
         */
        selectedMotion: function () {
            return this.$store.getters.getActiveMotion;
        },


        ariaStatus : function (){
            if (this.isSelected) {
                return 'true'
                // return ' bg-info '
            }
            return 'false'
        },

        styling: {
            get: function () {
                if (this.isSelected) {
                    return ' active '
                    // return ' bg-info '
                }

            },
            default: ''
        },
        //
        // styling: {
        //     get: function () {
        //         if (this.isSelected) {
        //             return ' bg-info '
        //         }
        //
        //     },
        //     default: ''
        // },

        textStyling: function () {
            if (this.hasVoted) return 'text-muted';

            if (this.isError) return 'text-danger'
        }

    },


    methods: {
        handleSelect: function () {
            // window.console.log('setting office ');
            this.$store.dispatch('setOfficeForVoting', this.motion);
        }
    }

}
</script>

<style scoped>

</style>
